<template>
  <router-view v-slot="{ Component, route }">
    <keep-alive :include="keepAliveNames">
      <component
        :is="Component"
        :key="route.meta?.keepAlive ? route.name : route.name || route.path"
      />
    </keep-alive>
  </router-view>
</template>

<script setup lang="ts">
  import { computed } from 'vue';
  import { useRouter } from 'vue-router';

  const router = useRouter();

  const keepAliveNames = computed(() => {
    const routes = router.getRoutes();
    return routes.filter((r) => r.meta?.keepAlive).map((r) => r.name as string);
  });
</script>

<style lang="scss">
  @use './styles/variables' as *;

  #app {
    min-height: 100vh;
    margin: 0;
    padding: 0;
    font-family:
      -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'PingFang SC',
      'Hiragino Sans GB', 'Microsoft YaHei', sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: $text-color;
  }
</style>
